export default __webpack_public_path__ + "static/new8-08-6605d9e8c929edbf14be134305c1734b.jpg";